import { CapacitorAppStatus, CapacitorLifecycleState } from './capacitorLifecycleTypes';

export const selectCapacitorLifecycleState = (state: any): CapacitorLifecycleState =>
    state.getIn(['app', 'capacitorApp']);

export const selectCapacitorLifecycleStatus = (state: any): CapacitorAppStatus | undefined =>
    selectCapacitorLifecycleState(state)?.currentStatus;
